// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"206":"754da854","343":"67cf901d"}[chunkId] + ".chunk.css";
};